<template>
    <FinancialSituationCalculator ref="calculator" v-model="formValue"></FinancialSituationCalculator>
</template>

<script setup lang="ts">
import { App } from '../../../../typings/api-enums'
import { useVModel } from '@vueuse/core'
import { ecspLegalComplianceProfileConfig } from '../../../account/legal/complianceProfile/ecspComplianceProfile'
import { getLegalWidgetFormValidationRules, initializeLegalWidgetForm } from '../../ESAC/legal/form/forms'
import FinancialSituationCalculator from '../form/FinancialSituationCalculator.vue'
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'

const calculator = ref<InstanceType<typeof FinancialSituationCalculator> | null>(null)

const { saving } = storeToRefs(useLegalAccountDataState())

watch(saving, () => {
    calculator.value.updatedStoredValues()
})

const props = defineProps<{
    modelValue: App.Services.ComplianceProfile.ECSP.Categories.EcspFinancialSituationDto
}>()

const emit = defineEmits(['update:modelValue'])
const formValue = useVModel(props, 'modelValue', emit)

initializeLegalWidgetForm(
    getLegalWidgetFormValidationRules(ecspLegalComplianceProfileConfig['Financial Situation'].validationKey, 'ecsp'),
    'ecsp'
)
</script>
